/*global d3 */
// DEFINE VARIABLES
// Define size of map group
// Full world map is 2:1 ratio
// Using 12:13 because I'm trying to limit to Canada/US/Central/South
var w = 600;
var h = 650;

var minZoom;
var maxZoom;

var places = {
    whistlerCAN: [-122.952659, 50.127254],
    seattleWA: [-122.331775, 47.609142],
    portlanOR: [-124.006922, 45.512739],
    astoriaOR: [-123.832427, 46.188158],
    sanfranciscoCA: [-122.464683, 37.825534],
    losangelesCA: [-118.496380, 34.010329],
    lapazBAJA: [-110.314728, 24.151821],
    mazatlanSIN: [-106.410601, 23.250493],
    guadalajaraJAL: [-103.356354, 20.687583],
    guanajuatoGUA: [-101.224256, 21.076034],
    queretaroQUE: [-100.391345, 20.588640],
    metepecMET: [-99.598117, 19.253386],
    cdmxMEX: [ -99.144688, 19.432145],
    pachucaHID: [-98.760203, 20.101841],
    pueblaPUE: [ -98.209103, 19.041649],
    floresmagonOAX: [-97.073494, 18.133637],
    tuxtepecOAX: [-96.142570, 18.079769],
    coatzacoalcosVER: [-94.420700, 18.157694],
    paraisoTAB: [-93.211638, 18.400266],
    ciudaddelcarmCAM: [-91.796738, 18.743249],
    conhuasROO: [-89.888803, 18.536758],
    bacalarROO: [-88.394330, 18.677777]
};
    
//};
var routes = {
    type: "LineString",
    coordinates: [
        places.whistlerCAN,
        places.seattleWA,
        places.portlanOR,
        places.astoriaOR,
        places.sanfranciscoCA,
        places.losangelesCA,
        places.lapazBAJA,
        places.mazatlanSIN,
        places.guadalajaraJAL,
        places.guanajuatoGUA,
        places.queretaroQUE,
        places.metepecMET,
        places.cdmxMEX,
        places.pachucaHID,
        places.pueblaPUE,
        places.floresmagonOAX,
        places.tuxtepecOAX,
        places.coatzacoalcosVER,
        places.paraisoTAB,
        places.ciudaddelcarmCAM,
        places.conhuasROO,
        places.bacalarROO
    ]
};

var projection = d3.geoEquirectangular()
        .scale([300]) //w/(Math.PI)
        .translate([w/2, w*1.2/2])
        .center([-80,-10]);

//accessor function
var path = d3.geoPath()
        .projection(projection);
// Create function to apply zoom to countriesGroup
function zoomed() {
    var t = d3
        .event
        .transform
;
    countriesGroup
        .attr("transform","translate(" + [t.x, t.y] + ")scale(" + t.k + ")")
    ;
    referenceLayer
        .attr("transform","translate(" + [t.x, t.y] + ")scale(" + t.k + ")")
    ;
    routeLayer
        .attr("transform","translate(" + [t.x, t.y] + ")scale(" + t.k + ")")
}
      // Define map zoom behaviour
var zoom = d3
.zoom()
.on("zoom", zoomed)
;

// Function that calculates zoom/pan limits and sets zoom to default value 
function initiateZoom() {
  // Define a "minzoom" whereby the "Countries" is as small possible without leaving white space at top/bottom or sides
  minZoom = Math.max($("#map-holder").width() / w, $("#map-holder").height() / h);
  // set max zoom to a suitable factor of this value
  maxZoom = 20 * minZoom;
  // set extent of zoom to chosen values
  // set translate extent so that panning can't cause map to move out of viewport
  zoom
    .scaleExtent([minZoom, maxZoom])
    .translateExtent([[0, 0], [w, h]])
  ;
  // define X and Y offset for centre of map to be shown in centre of holder
  midX = ($("#map-holder").width() - minZoom * w) / 2;
  midY = ($("#map-holder").height() - minZoom * h) / 2;
  // change zoom transform to min zoom and centre offsets
  svg.call(zoom.transform, d3.zoomIdentity.translate(midX, midY).scale(minZoom));
}

// zoom to show a bounding box, with optional additional padding as percentage of box size
function boxZoom(box, centroid, paddingPerc) {
  minXY = box[0];
  maxXY = box[1];
  // find size of map area defined
  zoomWidth = Math.abs(minXY[0] - maxXY[0]);
  zoomHeight = Math.abs(minXY[1] - maxXY[1]);
  // find midpoint of map area defined
  zoomMidX = centroid[0];
  zoomMidY = centroid[1];
  // increase map area to include padding
  zoomWidth = zoomWidth * (1 + paddingPerc / 100);
  zoomHeight = zoomHeight * (1 + paddingPerc / 100);
  // find scale required for area to fill svg
  maxXscale = $("svg").width() / zoomWidth;
  maxYscale = $("svg").height() / zoomHeight;
  zoomScale = Math.min(maxXscale, maxYscale);
  // handle some edge cases
  // limit to max zoom (handles tiny countries)
  zoomScale = Math.min(zoomScale, maxZoom);
  // limit to min zoom (handles large countries and countries that span the date line)
  zoomScale = Math.max(zoomScale, minZoom);
  // Find screen pixel equivalent once scaled
  offsetX = zoomScale * zoomMidX;
  offsetY = zoomScale * zoomMidY;
  // Find offset to centre, making sure no gap at left or top of holder
  dleft = Math.min(0, $("svg").width() / 2 - offsetX);
  dtop = Math.min(0, $("svg").height() / 2 - offsetY);
  // Make sure no gap at bottom or right of holder
  dleft = Math.max($("svg").width() - w * zoomScale, dleft);
  dtop = Math.max($("svg").height() - h * zoomScale, dtop);
  // set zoom
  svg
    .transition()
    .duration(500)
    .call(
      zoom.transform,
      d3.zoomIdentity.translate(dleft, dtop).scale(zoomScale)
    );
}




// on window resize
$(window).resize(function() {
  // Resize SVG
  svg
    .attr("width", $("#map-holder").width())
    .attr("height", $("#map-holder").height())
  ;
  initiateZoom();
});

var svg = d3
    .select("#map-holder")
    .append("svg")
    .attr("class", "map-svg")
    // set to the same size as the "map-holder" div
    .attr("width", $("#map-holder").width())
    .attr("height", $("#map-holder").width()*1.2)
    .call(zoom)
;
var countriesGroup = svg.append("g").attr("id", "map");

    
    countriesGroup.append("rect")
      .attr("x", 0)
      .attr("y", 0)
      .attr("width", w)
      .attr("height", w*1.2)
;

var routeLayer = svg.append("g").attr("id", "route");
var referenceLayer = svg.append("g").attr("id", "points");

function getTextBox(selection) {
  selection
    .each(function(d) {
      d.bbox = this
        .getBBox();
      })
  ;
}

function update(geojson) {

    
    var countries = countriesGroup
        .selectAll('path')
        .data(geojson.features)
        .enter()
        .append('path')
        .attr('d', path)
        .attr("id", function(d, i) {
            return d.properties.name;
        })
      .attr("class", "country")
    .on('mouseover', function () {
                        var region = d3.select(this);
                        document.querySelector('.legend').innerText = region.attr('id');
                    }).on('mouseout', function () {
                        document.querySelector('.legend').innerText = '';
                    })
    .on("click", function(d,i) {
        d3.selectAll(".country").classed("country-on", false);
        d3.select(this).classed("country-on", true)
    });
    initiateZoom();
};


function projectRoute(routes) {
    var routexy = [];
    for (i=0; i< routes.length; i++) {
        routexy.push(projection(routes[i]));  
    }
    return routexy;
}
//translateRoute(routes);
//console.log(routexy);

var lineGenerator = d3.line()
    .x(function(d) {return d[0]})
    .y(function(d) {return d[1]})
    .curve(d3.curveCardinal);

function drawRoute(data) {
  var line = routeLayer
  .append("path")
//  .datum({ "type": "LineString", "coordinates": data })
  .datum(data)
  .attr('d', lineGenerator)
  .attr("class", "route")
  }

function drawPoints(data, r, layer) {
  var dots = layer
  .selectAll('circle')
  .data(data)
  .enter()
  .append("circle")
  .attr("cx", function(d) {return d[0]})
  .attr("cy", function(d) {return d[1]})
  .attr("r", r)
  .attr("class", "point")
  }
function drawStartEnd(data) {
  var startEnd = routeLayer
  .selectAll("image")
  .data(data)
  .enter()
  .append("image")
  .attr('xlink:href', '/assets/images/loader.svg')
  //x, y refer to top left corner of svg, center by substracting half of width and height
  .attr("x", function(d) {return d[0]-10})
  .attr("y", function(d) {return d[1]-10})
  .attr("width", 20)
  .attr("height", 20)
  }
  
d3.json('/data/geo/', update)

d3.csv("https://docs.google.com/spreadsheets/d/e/2PACX-1vQgRpb8fGW6eADwg0lSLmo3wepIhfH7gYfIqUlWWBQUYk8ZiBU0PDs3wmyyfT9lP2NK16FhhmpBuuHq/pub?gid=0&single=true&output=csv",
       function(data){
//    console.log(data);
    var routeOne = [];
    var routeTwo = [];
    var majorPoints = [];
    var referencePoints = [];
    var startEndPoints = [];
    for (i=0; i<data.length; i++) {
        if(data[i].type=="route" && data[i].sub==1) {
            var longlat= [data[i].long,data[i].lat]
            routeOne.push(longlat);
        }
        if(data[i].type=="route" && data[i].sub==2) {
            var longlat= [data[i].long,data[i].lat]
            routeTwo.push(longlat);
        }
        if(data[i].desc=='major') {
            var longlat= [data[i].long,data[i].lat]
            majorPoints.push(longlat);
        }
        if(data[i].desc=='reference') {
            var longlat= [data[i].long,data[i].lat]
            referencePoints.push(longlat);
        }
        if(data[i].desc2=='start' || data[i].desc2=='end') {
            var longlat= [data[i].long,data[i].lat]
            startEndPoints.push(longlat);
        }
    }
    drawRoute(projectRoute(routeOne));
    drawRoute(projectRoute(routeTwo));
    drawPoints(projectRoute(majorPoints), 1.5, routeLayer);
    drawPoints(projectRoute(referencePoints), 2.5, referenceLayer);
    drawStartEnd(projectRoute(startEndPoints));
})



